<div class="justup-dialog">
  <vl-header-dialog (close)="dialogRef.close()" [rightElement]="excelBtn">
    {{ 'dashboard_ui.w_nc_supplier_compliance' | trans }}
  </vl-header-dialog>

  <ng-template #excelBtn>
    <vl-excel-export-button size="medium"
                            [loading]="exporting()"
                            [disabled]="exporting()"
                            [tooltip]="'dashboard_ui.export_excel' | trans"
                            (action)="exportExcel()"/>
  </ng-template>

  <div class="justup-dialog-content flex-col gap-16">
    <span class="caption on-background-alt">Période : {{ data.data?.start }} → {{ data.data?.end }}</span>

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="secondary" icon="business"
                     title="Fournisseurs analysés"
                     style="flex: 1; min-width: 150px">
        <span content class="headline">{{ totalFournisseurs() }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="warning"
                     title="NC totales"
                     style="flex: 1; min-width: 150px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ totalNc() }}</span>
          <span class="tiny" style="opacity: 0.7">dont {{ totalCritiques() }} critiques</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="valid" icon="trending_up"
                     title="Taux moyen — Top"
                     style="flex: 1; min-width: 150px">
        <span content class="headline">{{ fmtTaux(moyTauxBest()) }}</span>
      </vl-radio-card>
    </div>

    <!-- Worst suppliers -->
    @if (worst().length) {
      <div class="section">
        <span class="subheading-2">{{ 'dashboard_ui.nc_titre_pires' | trans }}</span>
        <div class="flex-col gap-4 mt-8">
          @for (s of worst(); track s.tiersId) {
            <div class="row-supplier">
              <span class="grow body-2 ellipsis" [matTooltip]="s.denomination">{{ s.denomination }}</span>
              <span class="caption-2 on-background-alt shrink-0">{{ s.nbReceptions }} récept.</span>
              <span class="caption-2 on-background-alt shrink-0">{{ s.nbNc }} NC</span>
              @if (s.nbNcCritiques > 0) {
                <span class="caption-2 critique shrink-0">{{ s.nbNcCritiques }} crit.</span>
              }
              @if (s.coutNc > 0) {
                <span class="caption-2 on-background-alt shrink-0">{{ s.coutNc | number:'1.0-0' }} €</span>
              }
              <span class="taux-pill shrink-0"
                    [class.taux-bad]="s.tauxConformite != null && s.tauxConformite < 90"
                    [class.taux-warn]="s.tauxConformite != null && s.tauxConformite >= 90 && s.tauxConformite < 95"
                    [class.taux-ok]="s.tauxConformite != null && s.tauxConformite >= 95"
                    [class.taux-na]="s.tauxConformite == null">{{ fmtTaux(s.tauxConformite) }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Best suppliers -->
    @if (best().length) {
      <div class="section">
        <span class="subheading-2">{{ 'dashboard_ui.nc_titre_meilleurs' | trans }}</span>
        <div class="flex-col gap-4 mt-8">
          @for (s of best(); track s.tiersId) {
            <div class="row-supplier">
              <span class="grow body-2 ellipsis" [matTooltip]="s.denomination">{{ s.denomination }}</span>
              <span class="caption-2 on-background-alt shrink-0">{{ s.nbReceptions }} récept.</span>
              <span class="caption-2 on-background-alt shrink-0">{{ s.nbNc }} NC</span>
              <span class="taux-pill shrink-0"
                    [class.taux-bad]="s.tauxConformite != null && s.tauxConformite < 90"
                    [class.taux-warn]="s.tauxConformite != null && s.tauxConformite >= 90 && s.tauxConformite < 95"
                    [class.taux-ok]="s.tauxConformite != null && s.tauxConformite >= 95"
                    [class.taux-na]="s.tauxConformite == null">{{ fmtTaux(s.tauxConformite) }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<style>
.justup-dialog .section {
  background: var(--color-canvas);
  border: 1px solid var(--color-on-disabled);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
}

.justup-dialog .row-supplier {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: var(--color-canvas);
  border: 1px solid var(--color-on-disabled);
  border-radius: 8px;
}

.justup-dialog .row-supplier .ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.justup-dialog .row-supplier .taux-pill {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 999px;
  min-width: 64px;
  text-align: center;
  border: 1px solid currentColor;
  font-size: 12px;
}

.justup-dialog .row-supplier .taux-pill.taux-ok {
  color: #067647;
  background: #ECFDF3;
  border-color: #ABEFC6;
}

.justup-dialog .row-supplier .taux-pill.taux-warn {
  color: #B54708;
  background: #FFF4E5;
  border-color: #FEDF89;
}

.justup-dialog .row-supplier .taux-pill.taux-bad {
  color: #B42318;
  background: #FEF3F2;
  border-color: #FECDCA;
}

.justup-dialog .row-supplier .taux-pill.taux-na {
  color: var(--color-on-background-alt);
  background: var(--color-canvas);
  border-color: var(--color-on-disabled);
}

.justup-dialog .row-supplier .critique {
  color: var(--color-error);
}
</style>
